import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-crop-sharp",
  "use": "icon-crop-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-crop-sharp\"><title>Crop</title><path d=\"M166 346V32h-44v90H32v44h90v224h224v90h44v-90h90v-44H166z\" /><path d=\"M346 320h44V122H192v44h154v154z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol